export const certificationInitValue = {
  label: "",
  value: "",
};
export const affiliatedGymsInitValue = {
  affiliatedGymsName: "",
};
